// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"864ab968","453":"12af527a","667":"eebc345c","977":"040f584e"}[chunkId] + ".chunk.js";
};